import { render, staticRenderFns } from "./FrameworkControlViewModal.vue?vue&type=template&id=0866c4b4&"
import script from "./FrameworkControlViewModal.vue?vue&type=script&lang=js&"
export * from "./FrameworkControlViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports